import { render, staticRenderFns } from "./ErrorDisplay.vue?vue&type=template&id=033e9ee1&scoped=true"
import script from "./ErrorDisplay.vue?vue&type=script&lang=js"
export * from "./ErrorDisplay.vue?vue&type=script&lang=js"
import style0 from "./ErrorDisplay.vue?vue&type=style&index=0&id=033e9ee1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033e9ee1",
  null
  
)

export default component.exports